export const SendNoteModalVariant = {
  DEFAULT: 'DEFAULT',
  REJECTION_REASON: 'REJECTION_REASON',
}
